import {Subscribable} from './subscribable';

export class BaseDirective extends Subscribable {
}
